import type { IconSvgElement } from '@hugeicons/react';
import { createElement } from 'react';

import { ArticIconShell, type ArticIconProps } from './shell';

export type HugeIconComponentProps = ArticIconProps & {
  strokeWidth?: number;
};

export function createHugeIcon(iconData: IconSvgElement, displayName: string) {
  function HugeIconComponent({ strokeWidth = 2, ...props }: HugeIconComponentProps) {
    return (
      <ArticIconShell {...props} viewBox="0 0 24 24">
        {iconData.map(([tag, attrs], index) => {
          const elementAttrs: Record<string, unknown> = { ...attrs };
          if ('strokeWidth' in elementAttrs) {
            elementAttrs['strokeWidth'] = strokeWidth;
          }
          const rawKey = attrs['key'];
          const key = typeof rawKey === 'string' ? rawKey : String(index);
          delete elementAttrs['key'];
          return createElement(tag, { ...elementAttrs, key });
        })}
      </ArticIconShell>
    );
  }
  HugeIconComponent.displayName = displayName;
  return HugeIconComponent;
}
